/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Force_End_Note_LabelInputs */

const vi_trip_force_end_note_label = /** @type {(inputs: Trip_Force_End_Note_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú lý do (không bắt buộc)`)
};

/**

* @param {Trip_Force_End_Note_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_force_end_note_label = /** @type {((inputs?: Trip_Force_End_Note_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Force_End_Note_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_force_end_note_label(inputs)
});